import { render, staticRenderFns } from "./weekTeachLockTable.vue?vue&type=template&id=1ee5c21c&"
import script from "./weekTeachLockTable.vue?vue&type=script&lang=js&"
export * from "./weekTeachLockTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports